// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// export default function MyRestaurantsScreen() {
//   const navigate = useNavigate();
  
//   // Navigation & Selection States
//   const [view, setView] = useState("list"); // 'list' or 'details'
//   const [selectedMerchantId, setSelectedMerchantId] = useState(null);

//   // API States
//   const [restaurants, setRestaurants] = useState([]);
//   const [rewardDetails, setRewardDetails] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [detailsLoading, setDetailsLoading] = useState(false);
//   const [error, setError] = useState(null);

//   // Helper to clean "DATABASE CONNECTED" from response
//   const cleanAndParseJson = (text) => {
//     const cleanString = text.replace("DATABASE CONNECTED", "").trim();
//     return JSON.parse(cleanString);
//   };

//   // Fetch all restaurants list
//   const fetchRestaurants = async () => {
//     setLoading(true);
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", "CMVC497B3A688");
//       formdata.append("merchant_id", "CMV9A117EAC");

//       const response = await fetch("https://countmyvisit.com/Apis/my_restaurants.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         setRestaurants(data.restaurants || []);
//       } else {
//         setError("Failed to load your restaurants.");
//       }
//     } catch (err) {
//       console.error(err);
//       setError("Something went wrong while fetching restaurants.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch specific restaurant rewards details
//   const fetchRestaurantRewards = async (merchantId) => {
//     setDetailsLoading(true);
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", "CMVC497B3A688");
//       formdata.append("merchant_id", merchantId);

//       const response = await fetch("https://countmyvisit.com/Apis/restaurant_rewards.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         setRewardDetails(data);
//         setView("details");
//       } else {
//         alert("Failed to load reward roadmap for this restaurant.");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Error fetching restaurant loyalty details.");
//     } finally {
//       setDetailsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchRestaurants();
//   }, []);

//   if (loading) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "Poppins, sans-serif", fontSize: "18px", fontWeight: "600", color: "#ff8c42" }}>
//         Loading Your of this maitian  and use of this Restaurants...
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "Poppins, sans-serif", fontSize: "16px", color: "#ef4444" }}>
//         {error}
//       </div>
//     );
//   }

//   return (
//     <>
//       <style>{`
//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//           font-family: 'Poppins', sans-serif;
//         }

//         body {
//           background: #f8fafc;
//         }

//         .container {
//           min-height: 100vh;
//           padding: 35px;
//           background: linear-gradient(135deg, #fffcf9, #fff, #f4f7ff);
//         }

//         /* HEADER */
//         .header-section {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 35px;
//           border-bottom: 1px solid #e2e8f0;
//           padding-bottom: 20px;
//         }

//         .header-title h1 {
//           font-size: 34px;
//           font-weight: 800;
//           color: #1e293b;
//         }

//         .header-title p {
//           color: #64748b;
//           font-size: 15px;
//           margin-top: 4px;
//         }

//         .back-btn {
//           padding: 12px 24px;
//           border: none;
//           background: #1e293b;
//           color: white;
//           border-radius: 14px;
//           font-weight: 600;
//           cursor: pointer;
//           transition: 0.2s;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .back-btn:hover {
//           transform: translateX(-3px);
//           background: #334155;
//         }

//         /* RESTAURANT LIST GRID */
//         .restaurant-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
//           gap: 25px;
//         }

//         .res-card {
//           background: white;
//           border-radius: 24px;
//           padding: 28px;
//           box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
//           border: 1px solid #f1f5f9;
//           cursor: pointer;
//           transition: 0.3s ease;
//           position: relative;
//           overflow: hidden;
//         }

//         .res-card:hover {
//           transform: translateY(-6px);
//           box-shadow: 0 20px 40px rgba(255, 140, 66, 0.1);
//           border-color: #ffdcd0;
//         }

//         .res-icon {
//           width: 60px;
//           height: 60px;
//           background: #fff3eb;
//           border-radius: 16px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 28px;
//           margin-bottom: 20px;
//         }

//         .res-card h3 {
//           font-size: 22px;
//           color: #0f172a;
//           text-transform: capitalize;
//           margin-bottom: 6px;
//         }

//         .res-meta {
//           font-size: 14px;
//           color: #64748b;
//           margin-bottom: 20px;
//           text-transform: capitalize;
//         }

//         .res-stats {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           background: #f8fafc;
//           padding: 12px 18px;
//           border-radius: 14px;
//         }

//         .visit-badge {
//           background: linear-gradient(135deg, #ff8c42, #ff5e62);
//           color: white;
//           padding: 4px 10px;
//           border-radius: 20px;
//           font-size: 13px;
//           font-weight: 700;
//         }

//         /* DETAILS SCREEN SPECIFIC */
//         .merchant-profile-card {
//           background: linear-gradient(135deg, #1e293b, #0f172a);
//           color: white;
//           border-radius: 30px;
//           padding: 35px;
//           margin-bottom: 35px;
//           box-shadow: 0 15px 35px rgba(15, 23, 42, 0.15);
//           position: relative;
//         }

//         .merchant-profile-card h2 {
//           font-size: 32px;
//           margin-bottom: 10px;
//           text-transform: capitalize;
//         }

//         .merchant-info-row {
//           display: flex;
//           gap: 25px;
//           flex-wrap: wrap;
//           margin-top: 15px;
//           color: #cbd5e1;
//           font-size: 14px;
//         }

//         .info-tag {
//           background: rgba(255, 255, 255, 0.1);
//           padding: 6px 14px;
//           border-radius: 20px;
//           text-transform: capitalize;
//         }

//         .current-visit-banner {
//           position: absolute;
//           right: 35px;
//           top: 35px;
//           background: linear-gradient(135deg, #ff8c42, #ff5e62);
//           padding: 15px 25px;
//           border-radius: 20px;
//           text-align: center;
//           box-shadow: 0 10px 25px rgba(255, 94, 98, 0.3);
//         }

//         .current-visit-banner h4 {
//           font-size: 28px;
//           font-weight: 800;
//         }

//         /* REWARDS ROADMAP CARDS */
//         .roadmap-title {
//           font-size: 24px;
//           color: #1e293b;
//           margin-bottom: 20px;
//           font-weight: 700;
//         }

//         .rewards-list-container {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//           gap: 25px;
//         }

//         .reward-roadmap-card {
//           background: white;
//           border-radius: 24px;
//           padding: 28px;
//           box-shadow: 0 10px 30px rgba(0,0,0,0.03);
//           border: 2px solid #f1f5f9;
//           display: flex;
//           flex-direction: column;
//           justify-content: space-between;
//           position: relative;
//         }

//         .reward-roadmap-card.unlocked {
//           border-color: #22c55e;
//           background: #f0fdf4;
//         }

//         .status-badge {
//           align-self: flex-start;
//           padding: 6px 14px;
//           border-radius: 30px;
//           font-size: 12px;
//           font-weight: 700;
//           text-transform: uppercase;
//           margin-bottom: 15px;
//         }

//         .status-badge.locked {
//           background: #fee2e2;
//           color: #ef4444;
//         }

//         .status-badge.unlocked {
//           background: #dcfce7;
//           color: #15803d;
//         }

//         .reward-roadmap-card h4 {
//           font-size: 20px;
//           color: #0f172a;
//           margin-bottom: 8px;
//         }

//         .reward-gift-detail {
//           font-size: 16px;
//           color: #ff6b35;
//           font-weight: 700;
//           margin-bottom: 20px;
//         }

//         .progress-container {
//           margin-top: auto;
//         }

//         .progress-bar-bg {
//           height: 10px;
//           background: #e2e8f0;
//           border-radius: 10px;
//           overflow: hidden;
//           margin-bottom: 10px;
//         }

//         .progress-bar-fill {
//           height: 100%;
//           background: linear-gradient(135deg, #ff8c42, #ff5e62);
//           border-radius: 10px;
//         }

//         .progress-txt {
//           font-size: 13px;
//           color: #64748b;
//           display: flex;
//           justify-content: space-between;
//         }

//         @media(max-width: 768px) {
//           .container { padding: 20px; }
//           .header-section { flex-direction: column; align-items: flex-start; gap: 15px; }
//           .merchant-profile-card { padding: 25px; padding-top: 100px; }
//           .current-visit-banner { left: 25px; top: 20px; right: auto; width: calc(100% - 50px); display: flex; justify-content: space-between; align-items: center; padding: 10px 20px; }
//           .current-visit-banner h4 { font-size: 20px; }
//         }
//       `}</style>

//       <div className="container">
        
//         {/* LIST VIEW SCREEN */}
//         {view === "list" && (
//           <div>
//             <div className="header-section">
//               <div className="header-title">
//                 <h1>My Restaurants</h1>
//                 <p>Explore your footprints and loyalty structures across merchants</p>
//               </div>
//               <button className="back-btn" onClick={() => navigate(-1)}>
//                 ← Dashboard
//               </button>
//             </div>

//             {restaurants.length === 0 ? (
//               <div style={{ textAlign: "center", padding: "50px", color: "#64748b" }}>
//                 <span style={{ fontSize: "40px" }}>🍽️</span>
//                 <p style={{ marginTop: "10px", fontSize: "16px" }}>You haven't visited any restaurants yet.</p>
//               </div>
//             ) : (
//               <div className="restaurant-grid">
//                 {restaurants.map((res) => (
//                   <div 
//                     key={res.merchant_id} 
//                     className="res-card"
//                     onClick={() => fetchRestaurantRewards(res.merchant_id)}
//                   >
//                     <div className="res-icon">
//                       {res.business_type === "resturant" ? "🍕" : "☕"}
//                     </div>
//                     <h3>{res.business_name}</h3>
//                     <p className="res-meta">{res.business_type} • By {res.owner_name}</p>
                    
//                     <div className="res-stats">
//                       <span style={{ fontSize: "14px", color: "#475569", fontWeight: "500" }}>Total Visits Done</span>
//                       <span className="visit-badge">{res.visits} {res.visits === 1 ? "Visit" : "Visits"}</span>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         )}

//         {/* DETAILS ROADMAP SCREEN */}
//         {view === "details" && rewardDetails && (
//           <div>
//             <div className="header-section">
//               <div className="header-title">
//                 <h1>Loyalty Timeline</h1>
//                 <p>Track your milestones and claimable prizes</p>
//               </div>
//               <button className="back-btn" onClick={() => setView("list")}>
//                 ← Back to List
//               </button>
//             </div>

//             {/* Merchant Top Banner Profile */}
//             <div className="merchant-profile-card">
//               <h2>{rewardDetails.merchant.business_name}</h2>
//               <p style={{ color: "#94a3b8", textTransform: "capitalize" }}>Type: {rewardDetails.merchant.business_type}</p>
              
//               <div className="merchant-info-row">
//                 <div className="info-tag">Owner: {rewardDetails.merchant.owner_name}</div>
//                 <div className="info-tag">📍 {rewardDetails.merchant.address}</div>
//                 <div className="info-tag">ID: {rewardDetails.merchant.merchant_id}</div>
//               </div>

//               <div className="current-visit-banner">
//                 <span style={{ fontSize: "12px", textTransform: "uppercase", fontWeight: "700", letterSpacing: "1px" }}>Your Visits</span>
//                 <h4>{rewardDetails.current_visit}</h4>
//               </div>
//             </div>

//             {/* Rewards Grid Container */}
//             <h3 className="roadmap-title">🎯 Available Milestones </h3>
//             <div className="rewards-list-container">
//               {rewardDetails.rewards.map((reward) => {
//                 const progressPct = Math.min((reward.current_visit / reward.required_visits) * 100, 100);
                
//                 return (
//                   <div 
//                     key={reward.pass_id} 
//                     className={`reward-roadmap-card ${reward.completed ? "unlocked" : ""}`}
//                   >
//                     <span className={`status-badge ${reward.status.toLowerCase()}`}>
//                       {reward.status === "Unlocked" ? "🎉 Unlocked" : "🔒 Locked"}
//                     </span>

//                     <h4>{reward.title}</h4>
//                     <p className="reward-gift-detail">Gift : {reward.reward}</p>

//                     <div className="progress-container">
//                       <div className="progress-bar-bg">
//                         <div className="progress-bar-fill" style={{ width: `${progressPct}%` }}></div>
//                       </div>
//                       <div className="progress-txt">
//                         <span>Progress: {reward.current_visit}/{reward.required_visits}</span>
//                         {reward.remaining_visits > 0 && (
//                           <span style={{ fontWeight: "600", color: "#ff6b35" }}>{reward.remaining_visits} more left</span>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         )}

//       </div>
//     </>
//   );
// }

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function MyRestaurantsScreen() {
  const navigate = useNavigate();
  
  // API States
  const [restaurants, setRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Helper to clean "DATABASE CONNECTED" from response
  const cleanAndParseJson = (text) => {
    const cleanString = text.replace("DATABASE CONNECTED", "").trim();
    return JSON.parse(cleanString);
  };

  // Fetch all restaurants list on mount
  const fetchRestaurants = async () => {
    setLoading(true);
    try {
      const formdata = new FormData();
      formdata.append("customer_id", "CMVC497B3A688");
      formdata.append("merchant_id", "CMV9A117EAC");

      const response = await fetch("https://countmyvisit.com/Apis/my_restaurants.php", {
        method: "POST",
        body: formdata,
        redirect: "follow"
      });
      const resText = await response.text();
      const data = cleanAndParseJson(resText);

      if (data.success) {
        setRestaurants(data.restaurants || []);
      } else {
        setError("Failed to load your restaurants.");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong while fetching restaurants.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch specific restaurant rewards details and instantly navigate to Visit Dashboard
  const fetchRestaurantRewardsAndNavigate = async (merchantId) => {
    setDetailsLoading(true);
    try {
      const formdata = new FormData();
      formdata.append("customer_id", "CMVC497B3A688");
      formdata.append("merchant_id", merchantId);

      const response = await fetch("https://countmyvisit.com/Apis/restaurant_rewards.php", {
        method: "POST",
        body: formdata,
        redirect: "follow"
      });
      const resText = await response.text();
      const data = cleanAndParseJson(resText);

      if (data.success) {
        // डेटा के साथ सीधे Visit Dashboard रूट पर नेविगेट करें
        navigate("/visit-dashboard", { state: { rewardDetails: data } });
      } else {
        alert("Failed to load reward roadmap for this restaurant.");
      }
    } catch (err) {
      console.error(err);
      alert("Error fetching restaurant loyalty details.");
    } finally {
      setDetailsLoading(false);
    }
  };

  useEffect(() => {
    fetchRestaurants();
  }, []);

  // Full Screen Main Loading State
  if (loading) {
    return (
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "Poppins, sans-serif", fontSize: "18px", fontWeight: "600", color: "#ff8c42", gap: "12px", background: "#f8fafc" }}>
        <div className="spinner" style={{ width: "40px", height: "40px", border: "4px solid #f3f3f3", borderTop: "4px solid #ff8c42", borderRadius: "50%", animation: "spin 1s linear infinite" }}></div>
        Loading Your Restaurants...
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  // Error State Layout
  if (error) {
    return (
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "Poppins, sans-serif", fontSize: "16px", color: "#ef4444", background: "#f8fafc" }}>
        <span style={{ fontSize: "40px", marginBottom: "10px" }}>⚠️</span>
        <p>{error}</p>
        <button onClick={fetchRestaurants} style={{ marginTop: "15px", padding: "10px 20px", background: "#1e293b", color: "#fff", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: "500" }}>Try Again</button>
      </div>
    );
  }

  return (
    <>
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          font-family: 'Poppins', sans-serif;
        }

        body {
          background: #f8fafc;
        }

        .container {
          min-height: 100vh;
          padding: 35px;
          background: linear-gradient(135deg, #fffcf9, #fff, #f4f7ff);
        }

        /* HEADER SECTION */
        .header-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 35px;
          border-bottom: 1px solid #e2e8f0;
          padding-bottom: 20px;
        }

        .header-title h1 {
          font-size: 34px;
          font-weight: 800;
          color: #1e293b;
        }

        .header-title p {
          color: #64748b;
          font-size: 15px;
          margin-top: 4px;
        }

        .back-btn {
          padding: 12px 24px;
          border: none;
          background: #1e293b;
          color: white;
          border-radius: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .back-btn:hover {
          transform: translateX(-3px);
          background: #334155;
        }

        /* RESTAURANT LIST GRID */
        .restaurant-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
          gap: 25px;
        }

        .res-card {
          background: white;
          border-radius: 24px;
          padding: 28px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
          border: 1px solid #f1f5f9;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .res-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 40px rgba(255, 140, 66, 0.12);
          border-color: #ffdcd0;
        }

        .res-icon {
          width: 60px;
          height: 60px;
          background: #fff3eb;
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          margin-bottom: 20px;
        }

        .res-card h3 {
          font-size: 22px;
          color: #0f172a;
          text-transform: capitalize;
          margin-bottom: 6px;
        }

        .res-meta {
          font-size: 14px;
          color: #64748b;
          margin-bottom: 20px;
          text-transform: capitalize;
        }

        .res-stats {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #f8fafc;
          padding: 12px 18px;
          border-radius: 14px;
        }

        .visit-badge {
          background: linear-gradient(135deg, #ff8c42, #ff5e62);
          color: white;
          padding: 6px 14px;
          border-radius: 20px;
          font-size: 13px;
          font-weight: 700;
        }

        /* BLURRED LOADING OVERLAY */
        .loading-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255, 255, 255, 0.75);
          backdrop-filter: blur(5px);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          z-index: 9999;
          font-size: 18px;
          font-weight: 600;
          color: #ff8c42;
          gap: 12px;
        }

        @media(max-width: 768px) {
          .container { padding: 20px; }
          .header-section { flex-direction: column; align-items: flex-start; gap: 15px; }
          .back-btn { width: 100%; justify-content: center; }
        }
      `}</style>

      <div className="container">
        {/* Dynamic Transition Overlay Loader */}
        {detailsLoading && (
          <div className="loading-overlay">
            <div className="spinner" style={{ width: "40px", height: "40px", border: "4px solid #f3f3f3", borderTop: "4px solid #ff8c42", borderRadius: "50%", animation: "spin 1s linear infinite" }}></div>
            Opening Visit Dashboard...
          </div>
        )}

        {/* Dashboard Header */}
        <div className="header-section">
          <div className="header-title">
            <h1>My Restaurants</h1>
            <p>Explore your footprints and loyalty structures across merchants</p>
          </div>
          <button className="back-btn" onClick={() => navigate(-1)}>
            ← Dashboard
          </button>
        </div>

        {/* Restaurants Rendering */}
        {restaurants.length === 0 ? (
          <div style={{ textAlign: "center", padding: "80px 20px", color: "#64748b", background: "#fff", borderRadius: "24px", boxShadow: "0 10px 30px rgba(0,0,0,0.02)" }}>
            <span style={{ fontSize: "50px" }}>🍽️</span>
            <p style={{ marginTop: "15px", fontSize: "18px", fontWeight: "500" }}>You haven't visited any restaurants yet.</p>
          </div>
        ) : (
          <div className="restaurant-grid">
            {restaurants.map((res) => (
              <div 
                key={res.merchant_id} 
                className="res-card"
                onClick={() => fetchRestaurantRewardsAndNavigate(res.merchant_id)}
              >
                <div className="res-icon">
                  {res.business_type?.toLowerCase() === "resturant" || res.business_type?.toLowerCase() === "restaurant" ? "🍕" : "☕"}
                </div>
                <h3>{res.business_name}</h3>
                <p className="res-meta">{res.business_type} • By {res.owner_name}</p>
                
                <div className="res-stats">
                  <span style={{ fontSize: "14px", color: "#475569", fontWeight: "500" }}>Total Visits Done</span>
                  <span className="visit-badge">{res.visits} {parseInt(res.visits) === 1 ? "Visit" : "Visits"}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}